import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import ContactCustomerCare from './subcomponents/ContactCustomerCare';
import QueriesAndComplaints from './subcomponents/QueriesAndComplaints';
import { Route, Switch } from 'react-router-dom';

interface IContactProps {
	match: {
		path: string;
	};
}

const Index = ({ match }: IContactProps) => {
	return (
		<>
			<BreadcrumbsItem to="/dashboard/contact-us">{translate('path.contact.us')}</BreadcrumbsItem>
			<div style={{ width: '100%' }}>
				<Switch>
					<Route path={`${match.path}/:ticketNumber?`} exact>
						<QueriesAndComplaints />
						<ContactCustomerCare />
					</Route>
				</Switch>
			</div>
		</>
	);
};

export default Index;
